import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'rd-shared-error-sign',
  templateUrl: './error-sign.component.html',
  styleUrls: ['./error-sign.component.scss'],
})
export class ErrorSignComponent {
  @HostBinding('class.rd-shared-error-sign') componentClass = true;
}
